import React from "react";
import {
  Badge,
  Box,
  Card,
  CardBody,
  Flex,
  Heading,
  Link,
  Text,
  Wrap,
  WrapItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { networkOrganizationReportPath } from "../networkReportPaths";

const hasReport = (organization) =>
  organization.reportAvailable === true &&
  organization.organizationSurveyId !== null &&
  organization.organizationSurveyId !== undefined &&
  organization.organizationSurveyId !== "";

const NetworkPairingFactorGroup = ({ group, mode, networkId }) => {
  const isStrength = mode === "strength";
  const borderColor = useColorModeValue(
    isStrength ? "green.200" : "red.200",
    isStrength ? "green.600" : "red.600"
  );
  const accentBg = useColorModeValue(
    isStrength ? "green.50" : "red.50",
    isStrength ? "green.900" : "red.900"
  );
  const chipBg = useColorModeValue(
    isStrength ? "green.100" : "red.100",
    isStrength ? "green.800" : "red.800"
  );
  const chipColor = useColorModeValue(
    isStrength ? "green.900" : "red.900",
    isStrength ? "green.100" : "red.100"
  );
  const mutedColor = useColorModeValue("gray.600", "gray.300");
  const categoryText = isStrength ? "Strength" : "Development area";

  return (
    <Card
      as="article"
      variant="outline"
      borderColor={borderColor}
      borderLeftWidth="4px"
      data-testid="pairing-factor-group"
      data-mode={mode}
    >
      <CardBody py={{ base: 4, md: 5 }}>
        <Flex
          direction={{ base: "column", sm: "row" }}
          align={{ base: "start", sm: "center" }}
          justify="space-between"
          gap={3}
        >
          <Box minW={0}>
            <Heading size="sm" overflowWrap="anywhere">
              {group.name}
            </Heading>
            <Text mt={1} color={mutedColor} fontSize="xs">
              {group.categoryLabel
                ? `${categoryText} · ${group.categoryLabel}`
                : categoryText}
            </Text>
          </Box>
          <Badge
            flexShrink={0}
            px={3}
            py={1}
            borderRadius="full"
            bg={accentBg}
            color={chipColor}
            textTransform="none"
            fontSize="sm"
            aria-label={`${group.organizationCount} ${
              group.organizationCount === 1 ? "school" : "schools"
            }`}
          >
            {group.organizationCount} {group.organizationCount === 1
              ? "school"
              : "schools"}
          </Badge>
        </Flex>

        <Wrap mt={4} spacing={2} align="center">
          {group.organizations.map((organization) => (
            <WrapItem key={organization.id} maxW="100%">
              {hasReport(organization) ? (
                <Link
                  as={RouterLink}
                  to={networkOrganizationReportPath(
                    networkId,
                    organization.organizationSurveyId
                  )}
                  bg={chipBg}
                  color={chipColor}
                  borderRadius="full"
                  px={3}
                  py={1}
                  fontSize="sm"
                  fontWeight="semibold"
                  overflowWrap="anywhere"
                  _hover={{ textDecoration: "underline" }}
                  aria-label={`${organization.organizationName} report`}
                >
                  {organization.organizationName}
                </Link>
              ) : (
                <Text
                  bg={chipBg}
                  color={chipColor}
                  borderRadius="full"
                  px={3}
                  py={1}
                  fontSize="sm"
                  fontWeight="semibold"
                  overflowWrap="anywhere"
                >
                  {organization.organizationName}
                </Text>
              )}
            </WrapItem>
          ))}
        </Wrap>
      </CardBody>
    </Card>
  );
};

export default NetworkPairingFactorGroup;
